import React from "react";

import { SettingsConfirmModal } from "../../../../../components/modal/SettingsConfirmModal";
import { WarningExclaimSvg } from "../../../../../components/svg/WarningExclaimSvg";

type InvalidDatesModalProps = {
  onClose: () => void;
};

export const InvalidDatesModal: React.FC<InvalidDatesModalProps> = ({
  onClose,
}) => {
  return (
    <SettingsConfirmModal
      onClose={onClose}
      onConfirm={onClose}
      icon={<WarningExclaimSvg sizeCx={"h-6 w-6"} />}
      title={"Invalid Dates"}
      description={
        "Start date must be on or before the due date. Please adjust one of the dates to continue."
      }
      confirmText={"Ok"}
      variant={"primary"}
      iconVariant={"warning"}
      noCancel
      confirmButtonStyles={"mx-auto flex w-1/2 justify-center px-4 py-2"}
    />
  );
};
